<template>
    <div class="collect-button-wrapper" :style="buttonStyle" v-debounce:collectCardTrigger.prevent>
        <div class="collect-count" :style="countStyle.base">
            <span :style="countStyle.prefix">{{collectText.prefix}}</span><span :style="countStyle.count">{{collectTextCount}}</span><span :style="countStyle.suffix">{{collectText.suffix}}</span>
        </div>

        <template v-if="showCollectCardError"> <!-- 展示集卡错误 -->
            <CollectCardError :info="collectCardErrorInfo" @emitEvent="receiveEvent" />
        </template>

        <template v-if="showCollectCardSuccess"> <!-- 展示收集到卡片 -->
            <CollectCardSuccess :info="collectCardSuccessInfo" @emitEvent="receiveEvent" />
        </template>


    </div>
</template>

<script>

import { CollectCardError, CollectCardSuccess } from './components'
var rem = require('@/utils/rem')

export default {

    name: 'CollectButton',

    components: {

        CollectCardError,

        CollectCardSuccess,

    },

    props: {

        info: {
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        pageDetail: { // 活动数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        receiveData: { // 接收数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        }

    },

    inject: ['$$activityId', '$$activityStatus', '$$activityType', 'getEnterSource'],

    watch: {

        'pageDetail.remainingOpportunities': { // 剩余的集卡次数
            handler(val) {
                this.getCountTextCount(val)
            }
        },

        receiveData: { // 接收数据
            handler(val) {
                this.dispatchEvent(val)
            },
            deep: true
        },

    },

    data() {

        return {

            buttonStyle: {}, // 集卡按钮样式

            countStyle: {}, // 集卡次数样式

            collectText: {}, // 剩余集卡次数

            collectTextCount: 0, // 剩余集卡次数数字

            showCollectCardError: false, // 展示集卡错误

            collectCardErrorInfo: {}, // 集卡错误信息

            showCollectCardSuccess: false, // 展示集卡成功

            collectCardSuccessInfo: {},    // 集卡成功信息

        }

    },

    computed: {
        enterSource() {
            return this.getEnterSource();
        },

        $activityStatus() {
            return this.$$activityStatus()
        },

        collectFailureConfig() { // 集卡按钮失败配置
            return this.info.collectFailureConfig || {}
        },

        collectSuccessConfig() { // 集卡按钮成功配置
            return this.info.collectSuccessConfig || {}
        },

    },

    mounted() {
    
        this.init()

        if (this.receiveData) {
            this.dispatchEvent(this.receiveData)
        }

    },

    methods: {

        init() { // init 函数

            this.initButtonStyle()

            this.initCountStyle()

            this.initCountText()

        },
        handleCss(options = {}) {
            let str= `.a${JSON.stringify(options).replace(/\"/g, '')}`
            let cssStyle  = rem.prototype.generateRem(str).toString()
            cssStyle  = cssStyle .substr(0, cssStyle .length - 1)
            cssStyle  = cssStyle .slice(7)
            return cssStyle.replace(/\,/g, ';')
        },
        initButtonStyle() { // 初始化集卡按钮样式
            let options = {}
            let collectButton = this.info.collectButtonConfig
            if (collectButton && collectButton.position1 && collectButton.position1.type) {
                options[`${collectButton.position1.type}`] =  `${collectButton.position1.value || 0}px`
            }
            if (collectButton && collectButton.position2 && collectButton.position2.type) {
                options[`${collectButton.position2.type}`] =  `${collectButton.position2.value || 0}px`
            }
            if (collectButton && collectButton.width) {
                options.width = `${collectButton.width}px`
            }
            if (collectButton && collectButton.height) {
                options.height = `${collectButton.height}px`
            }
            if (collectButton && collectButton.img && collectButton.img.url) {
                options = Object.assign(options, {
                    backgroundImage: `url(${collectButton.img.url})`,
                    backgroundSize: `100% 100%`,
                    backgroundPosition: `0px 0px`,
                })
            }
            this.buttonStyle = this.handleCss(options)
        },

        initCountStyle() { // 初始化集卡次数样式
            let count = this.info.collectCountConfig
            let options = {
                base: {},
                prefix: {},
                count: {},
                suffix: {}
            }
            for (let key in options) {
                let config = count[key]
                if (key === 'base') {
                    if (config && config.position1 && config.position1.type) {
                        options[key][`${config.position1.type}`] =  `${config.position1.value || 0}px`
                    }
                    if (config && config.position2 && config.position2.type) {
                        options[key][`${config.position2.type}`] =  `${config.position2.value || 0}px`
                    }
                } else {
                    options[key] = {
                        color: config.color,
                        fontSize: `${config.fontSize}px`,
                        textStroke: config.stroke ? `1px ${config.stroke}` : '',
                        fontWeight: config.fontStyle.indexOf('bold') !== -1 ? 'bold' : '',
                        fontStyle: config.fontStyle.indexOf('italic') !== -1 ? 'italic' : '',
                    }
                }
            }
            this.countStyle = options
            this.countStyle.base = this.handleCss(options.base)
        },

        initCountText() { // 初始化集卡次数文案
            let count = this.pageDetail.remainingOpportunities
            let config = this.info.collectCountConfig
            let collectText = {
                prefix: config.prefix.text,
                suffix: config.suffix.text
            }
            this.collectText = collectText
            this.getCountTextCount(count)
        },

        getCountTextCount(count) { // 获取集卡次数文案
            this.collectTextCount = !count ? 0 : (count < 10000 ? (count || 0) : '9999+')
        },

        collectCardTrigger() {  // 点击集卡按钮

            let status = this.$activityStatus
            if (status != 3) {
                return
            }
            if (!this.pageDetail.remainingOpportunities) {
                this.showCollectCardError = true
                this.collectCardErrorInfo = this.collectFailureConfig['lack']
            } else {
                this.$log.senLog({
                    pointID: '12010009',
                    eventType: 2,
                    businessData: {
                        activityType: this.$$activityType || '',
                        activityId: this.$$activityId || '',
                        enterSource: this.enterSource || '',
                    }
                })
                this.$emit('emitEvent', {
                    type: 'collectCardEvent',
                    data: null,
                    options: null
                })
            }
        },

        collectCardResponse(res, options) { // 接收集卡响应的结果
            if (res.success && res.model.hasWinCard) { // 集卡成功不放在这里 放在卡片那边去处理
                this.collectCardSuccessInfo = Object.assign(this.collectSuccessConfig, {
                    $$opts: res.model
                })
                // this.showCollectCardSuccess = true
                this.shareCollectSuccessCard(this.collectCardSuccessInfo)
            } else {
                this.showCollectCardError = true
                this.collectCardErrorInfo = this.collectFailureConfig['failure']
            }
        },

        closeCollectCardSuccess() { // 关闭集卡成功
            this.showCollectCardSuccess = false
            this.collectCardSuccessInfo = {}
        },

        closeCollectCardError() { // 关闭集卡出错
            this.showCollectCardError = false
            this.collectCardErrorInfo = {}
        },

        shareCollectSuccessCard(data, options) { // 分享集卡成功卡片
            this.$emit('emitEvent', {
                type: 'shareActivityEvent',
                data: {
                    shareType: 'lightCard',
                    cardId: data.$$opts.cardId
                },
                options: options
            })
        },

        dispatchEvent(e) { // 分发来自父级的事件
            const {
                type,
                data,
                options
            } = JSON.parse(JSON.stringify(e))
            this.$nextTick(() => {
                this[type] && this[type](data, options)
            })
        },

        receiveEvent(e) { // 接收子组件的事件
            let {
                type,
                data,
                options
            } = JSON.parse(JSON.stringify(e))
            this[type] && this[type](data, options)
        }

    }

}
</script>

<style  lang="scss" scoped>
.collect-button-wrapper {
    margin: 0;
	padding: 0;
	box-sizing: border-box;
	position: absolute;
    .collect-count {
        position: absolute;
        width: 100%;
        text-align: center;
    }
}
</style>